import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Utils, Grid } from 'billon-ui';

const { Button: ButtonModule } = Utils;
const { BackButton: BillonBackButton } = ButtonModule;
const { Card: BillonCard, Icon, Text } = Utils;
const { Col } = Grid;

export const FieldFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-content: flex-start;
`;

export const FC = styled.div`
  margin-right: 17px;
  align-self: center;
`;

export const FC2 = styled.div`
  padding-top: 2px;
  font-weight: ${({ theme }) => theme.fontWeightMedium};
`;

export const Card = styled(BillonCard)`
  margin: 0;
`;

export const CenterText = styled(BillonCard)`
  width: 100%;
`;
export const UnderlineLink = styled(Link)`
  text-decoration: underline;
`;

export const ImageIcon = styled(Icon)`
  color: #cad5dd;
`;

export const Title = styled.span`
  text-align: left;
  padding-bottom: 0.5rem;
  font-size: 1.8rem;
  font-weight: ${(props) => props.theme.fontWeightBold};
`;

export const CardBodyWrapper = styled.div`
  padding-top: 35px;
`;

export const ValidationIndicatorRow = styled.div`
  margin-top: -15px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 80%;
  margin-bottom: 15px;
`;

export const ValidationIndicatorLine = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 10px;
  height: 4px;
  background-color: ${(props) => props.theme.palette.grayLighter};
`;

export const ErrorLabel = styled(Text)`
  color: ${(props) => props.isErrorActive && props.theme.palette.error};
`;

export const StyledReactInputVerificationCode = styled.div`
  display: flex;
  margin-bottom: 5px;

  .ReactInputVerificationCode__item {
    font-weight: 500;
    border: 1px solid
      ${(props) => props.isInvalid && props.theme.palette.error2};
    border-radius: 4px;
    box-shadow: none;
  }

  .ReactInputVerificationCode__container {
    width: 100%;
  }

  .ReactInputVerificationCode__item.is-active {
    box-shadow: none;
    border: 1px solid #36c6d9;
  }
`;

export const VerificationCodeLabel = styled(Text)`
  margin-bottom: 5px;
`;

export const VerificationCodeErrorLabel = styled(Text)`
  color: ${(props) => props.theme.palette.error2};
  font-weight: ${(props) => props.theme.fontWeightBold};
  opacity: ${(props) => (props.isInvalid ? 1 : 0)};
  pointer-events: none;
`;

export const BackButton = styled(BillonBackButton)`
  padding: 0;
`;

export const ZeroCol = styled(Col)`
  padding-left: 0;
`;

export const Form = styled.div`
  min-height: 435px;
  position: relative;
`;
